module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABnSURBVHgB7dTRCYAwDATQCziII3UER3EER3AUR3EEN4jxo6CWUij313tQWvqREDgCyJAsP9x9jmsBz2Zm1+cnmuzOlXLt6dVnjXOC45nggPRgpqtM0x8hXalWm5UupYlHu6tFaRPgBv93ADlGFXx4AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hamburger.png
// module id = 551
// module chunks = 1